import { StyledContent as TauronWidthContainer } from './styles';

export default TauronWidthContainer;
